import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App.jsx';
import MapPage from './MapPage.jsx';
import TestMap from './TestMap.jsx';
import SparkMap from './SparkMap.jsx';
import HistoricalListingsPage from './pages/HistoricalListingsPage.jsx';
import SplitView from './SplitView.jsx';

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/map" element={<SparkMap />} />
        <Route path="/old-map" element={<MapPage />} />
        <Route path="/test-map" element={<TestMap />} />
        <Route path="/historical" element={<HistoricalListingsPage />} />
        <Route path="/split" element={<SplitView />} />
      </Routes>
    </BrowserRouter>
  );
}
